import { DISPLAY_NAME } from '../../config/app-config';
import React, { useState, useEffect } from 'react';
import { Snackbar, Alert } from '@mui/material';

export default function OfflineSnackbar({ offlineMode }) {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (offlineMode) {
            setOpen(true);
        }
    }, [offlineMode]);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    return (
        <Snackbar
            open={open}
            autoHideDuration={3000}
            onClose={handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
            <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                {DISPLAY_NAME} web services cannot be reached. Switching to offline mode!
                Cloud functions and enhanced search are unavailable.
            </Alert>
        </Snackbar>
    );
}
